import { ICountry } from '../destination';

export interface ICity {
  id: number;
  name: string;
  landOnly: boolean;
  countryId?: number;
  countryCode?: string;
  countryName?: string;
  destinationIds?: number[];
  longitude?: number;
  latitude?: number;
  /** @deprecated use countryId/countryCode/countryName */
  country?: ICountry;
}

export class City implements ICity {
  id!: number;
  name!: string;
  landOnly!: boolean;
  countryId?: number;
  countryCode?: string;
  countryName?: string;
  destinationIds?: number[];
  longitude?: number;
  latitude?: number;
  /** @deprecated use countryId/countryCode/countryName */
  country?: ICountry;
}
